export const  AuthRoutes = {
   
    login: "/auth/login",
    register:"/employees/addEmployeeRequest",
    checkEmail:"/auth/checkDuplicateEmail",
    checkPhone:"/auth/checkDuplicatePhone",
    changePassword:"/auth/changePassword",
    agentSignup:"/auth/agent/signup",
    agentLogin:"/auth/agent/login",
    agentVisit:"/auth/agent/visit",
    agentList:"/auth/agent/list",
    agentDelete: "/auth/agent/delete",
    stats:"/stats",
    investorStats:"/investorstats",

    agentFilterList:"/auth/agent/filterlist",
    agentReportExport:"/api/auth/agent/report/export",
    agentApprovalList:"/auth/agent/approved-list",

    getInvestors:"/auth/investors",
    createInvestor:"/auth/signup",
    deleteInvestor:"/auth/investors/delete",
    getInvestorById:"auth/investors/detail",
    updateInvestor:"/auth/investors/update",


    createBooking:"/bookings/booking/create",
    getBooking:"/bookings/getbookings",
    getBookingById:"/bookings/getbooking",
    deleteBooking:"/bookings/deletebooking",
    updateBooking:"/bookings/updatebooking",

    createFeedBack:'/bookings/create/feedback',
    updateAgentStatus:"/auth/update/agent",
    resetAgentPassword:"/auth/agent/reset-password",
    registerBooking:"/bookings/booking/register/visit",
    getAgentDetail:"/auth/agent/detail",

    createRequestListing:"/bookings/booking/requestlisting",
    getRequestListing:"/bookings/getrequestlistings",
    deleteRequestListing:"/bookings/deleterequestlisting",
    updateRequestListingStatus:"/bookings/updaterequestlistingstatus",
  };
    